import { render, staticRenderFns } from "./JsonResponse.vue?vue&type=template&id=25bc6615&scoped=true&"
import script from "./JsonResponse.vue?vue&type=script&lang=js&"
export * from "./JsonResponse.vue?vue&type=script&lang=js&"
import style0 from "./JsonResponse.vue?vue&type=style&index=0&id=25bc6615&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bc6615",
  null
  
)

export default component.exports